import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-getting-started-reviewing-content',
  templateUrl: './help-getting-started-reviewing-content.component.html',
  styleUrls: ['./help-getting-started-reviewing-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpGettingStartedReviewingContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
